import React from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'

interface MultiSelectProps {
  control: any
  indexByPage: number
  question: any
  setValue: any
  setError: any
  clearErrors: any
  isSubmitted: boolean
}

const MultiSelect: React.FC<MultiSelectProps> = (props) => {
  const { t } = useTranslation()
  const {
    control,
    indexByPage,
    question,
    setValue,
    clearErrors,
    setError,
    isSubmitted
  } = props

  const watchAnswers = useWatch({ control, name: `questions[${indexByPage}].answers` }) || []

  const errorMessage = t('Please select at least {{min}} items or no more then {{max}}', { min: question?.requiredMin, max: question?.requiredMax })

  return <FormFields.Select
    control={control}
    name={`questions[${indexByPage}].answers`}
    label={question?.question}
    multiple
    onChange={(e, { value }: {value: (string | number | boolean) []}) => {
      const answers = value.map(value => ({ answerId: value }))
      setValue(`questions[${indexByPage}].answers`, answers)
      if (answers.length >= question?.requiredMin && answers.length <= question?.requiredMax && isSubmitted) {
        clearErrors(`questions[${indexByPage}].answers`)
      }
    }}
    value={watchAnswers?.map(answer => answer.answerId) || []}
    rules={{
      validate: (value) => (value?.length >= question?.requiredMin && value?.length <= question?.requiredMax) || errorMessage
    }}
    placeholder={question?.placeholder}
    options={question?.answers?.map(anwser => ({ text: anwser?.answer, value: anwser?.id }))}
  />
}
export default MultiSelect